// extracted by mini-css-extract-plugin
export default {"pcf-table":"PcfTable_pcf-table__dzp0P"};